<button
    *ngIf="fileName"
    class="icon-button {{customClass}}"
    (click)="onButtonClicked()"
    [ngClass]="{ active: isActive }"
    [disabled]="isActive || disabled"
    [ngStyle]="{ '-webkit-mask-image': 'url(assets/icons/' + fileName + ')', 'mask-image': 'url(assets/icons/' + fileName + ')', 'background-color': color }"
></button>
